import zero from 'Images/battery/0.png';
import zeroRed from 'Images/battery/0-red.png';
import one from 'Images/battery/1.png';
import two from 'Images/battery/2.png';
import three from 'Images/battery/3.png';

export default {
  zero,
  zeroRed,
  one,
  two,
  three,
};
